import { ADMIN_ORGANIZATIONS_PATHS, ADMIN_PATH, ADMIN_TAB_PATHS } from '../../constants/paths.constants';
import { schools } from '../../services/bff.api';

export const ADMIN_SCHOOLNETS_RESOURCE = {
  key: 'ADMIN_SCHOOLNETS_RESOURCE',
  detailPath: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}/:id`,
  //   detailPath: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}/:name`,
  //   detailPathParam: 'name',
  table: {
    title: 'Schoolnetten',
    defaultSort: 'name',
    dataLocation: '_embedded.schoolNets.result',
    metaLocation: '_embedded.schoolNets.meta',
    disablePagination: true,
    searchParams: ['name'],
    fields: [{ value: 'name', label: 'Omschrijving', show: true, order: 0 }],
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i,
        name: i?.spoEntityData?.agodi?.name
      }))
  },
  api: {
    get: schools.getNets
  }
};
